module.exports = __webpack_public_path__ + "img/logo_blanc.12c8bc5f.png";